import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";

import { EQM2020_R01Dto } from "./Dto_EQM2020_R01";
import { EQM2020_R01Filter } from "./Store_EQM2020_R01";

const baseUrl = `${config.apiUrl}/EQM2020_R01`;

export const getEQM2020_R01List = async (option: string, params: Partial<EQM2020_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`
    return await getData<ResponseDto<EQM2020_R01Dto[]>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0
        } as EQM2020_R01Filter
    });
}

export const getEQM2020_R01AllCount = async (params: Partial<EQM2020_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: { 
            ...params
        } as EQM2020_R01Filter
    });
}

// export const getOrgDetail = async (orgCd: string) => {
//     const url = `${baseUrl}/organization/${orgCd}`;
//     return await getData<ResponseDto<EQM2020_R01Dto>>(url);
// }

export const postEQM2020_R01 = async (data: EQM2020_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<EQM2020_R01Dto[], ResponseDto<EQM2020_R01Dto[]>>(url, data);
}

export const patchEQM2020_R01 = async (data: EQM2020_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<EQM2020_R01Dto[], ResponseDto<EQM2020_R01Dto[]>>(url, data);
}

export const disableEQM2020_R01 = async (data: string[]) => {
    const url = `${baseUrl}/disable`;
    return await patchData<string[], ResponseDto<any>>(url, data);
}

export const deleteEQM2020_R01 = async (data: EQM2020_R01Dto) => {
    const url = `${baseUrl}`;
    return await deleteData<ResponseDto<any>>(url, { data: data });
}

export const downloadExcel_EQM2020_R01 = async (option: string, params: Partial<EQM2020_R01Filter>, listLength: number = 0) => {
    
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0 
        } as EQM2020_R01Filter
    });
}